/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { dataExportsCreateDestination } from "../funcs/dataExportsCreateDestination.js";
import { dataExportsCreateRoute } from "../funcs/dataExportsCreateRoute.js";
import { dataExportsDeleteDestination } from "../funcs/dataExportsDeleteDestination.js";
import { dataExportsDeleteRoute } from "../funcs/dataExportsDeleteRoute.js";
import { dataExportsListDestinations } from "../funcs/dataExportsListDestinations.js";
import { dataExportsListForOrg } from "../funcs/dataExportsListForOrg.js";
import { dataExportsListRoutes } from "../funcs/dataExportsListRoutes.js";
import { dataExportsUpdateDestination } from "../funcs/dataExportsUpdateDestination.js";
import { dataExportsUpdateRoute } from "../funcs/dataExportsUpdateRoute.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { DataExportRoute } from "../models/components/dataexportroute.js";
import { Destination } from "../models/components/destination.js";
import { ListDataExportRoutesResult } from "../models/components/listdataexportroutesresult.js";
import { ListDataExportsForOrgResult } from "../models/components/listdataexportsfororgresult.js";
import { ListDestinationsResult } from "../models/components/listdestinationsresult.js";
import {
  CreateDataExportDestinationRequest,
  CreateDataExportDestinationSecurity,
} from "../models/operations/createdataexportdestination.js";
import {
  CreateDataExportRouteRequest,
  CreateDataExportRouteSecurity,
} from "../models/operations/createdataexportroute.js";
import {
  DeleteDataExportDestinationRequest,
  DeleteDataExportDestinationSecurity,
} from "../models/operations/deletedataexportdestination.js";
import {
  DeleteDataExportRouteRequest,
  DeleteDataExportRouteSecurity,
} from "../models/operations/deletedataexportroute.js";
import {
  ListDataExportDestinationsRequest,
  ListDataExportDestinationsSecurity,
} from "../models/operations/listdataexportdestinations.js";
import {
  ListDataExportRoutesRequest,
  ListDataExportRoutesSecurity,
} from "../models/operations/listdataexportroutes.js";
import {
  ListDataExportsForOrgRequest,
  ListDataExportsForOrgSecurity,
} from "../models/operations/listdataexportsfororg.js";
import {
  UpdateDataExportDestinationRequest,
  UpdateDataExportDestinationSecurity,
} from "../models/operations/updatedataexportdestination.js";
import {
  UpdateDataExportRouteRequest,
  UpdateDataExportRouteSecurity,
} from "../models/operations/updatedataexportroute.js";
import { unwrapAsync } from "../types/fp.js";

export class DataExports extends ClientSDK {
  /**
   * createDestination dataExports
   *
   * @remarks
   * Create a data export destination in the selected project.
   */
  async createDestination(
    request: CreateDataExportDestinationRequest,
    security?: CreateDataExportDestinationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Destination> {
    return unwrapAsync(dataExportsCreateDestination(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createRoute dataExports
   *
   * @remarks
   * Create the selected data source's export route configuration.
   */
  async createRoute(
    request: CreateDataExportRouteRequest,
    security?: CreateDataExportRouteSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DataExportRoute> {
    return unwrapAsync(dataExportsCreateRoute(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteDestination dataExports
   *
   * @remarks
   * Delete a data export destination that is not referenced by an active route.
   */
  async deleteDestination(
    request: DeleteDataExportDestinationRequest,
    security?: DeleteDataExportDestinationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(dataExportsDeleteDestination(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteRoute dataExports
   *
   * @remarks
   * Delete a data source's export route configuration.
   */
  async deleteRoute(
    request: DeleteDataExportRouteRequest,
    security?: DeleteDataExportRouteSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(dataExportsDeleteRoute(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDestinations dataExports
   *
   * @remarks
   * List data export destinations for the selected project.
   */
  async listDestinations(
    request?: ListDataExportDestinationsRequest | undefined,
    security?: ListDataExportDestinationsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDestinationsResult> {
    return unwrapAsync(dataExportsListDestinations(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listForOrg dataExports
   *
   * @remarks
   * List data export destinations and routes across the active organization.
   */
  async listForOrg(
    request?: ListDataExportsForOrgRequest | undefined,
    security?: ListDataExportsForOrgSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDataExportsForOrgResult> {
    return unwrapAsync(dataExportsListForOrg(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRoutes dataExports
   *
   * @remarks
   * List data source export route configurations for the selected project.
   */
  async listRoutes(
    request?: ListDataExportRoutesRequest | undefined,
    security?: ListDataExportRoutesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDataExportRoutesResult> {
    return unwrapAsync(dataExportsListRoutes(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateDestination dataExports
   *
   * @remarks
   * Replace a data export destination in the selected project.
   */
  async updateDestination(
    request: UpdateDataExportDestinationRequest,
    security?: UpdateDataExportDestinationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Destination> {
    return unwrapAsync(dataExportsUpdateDestination(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateRoute dataExports
   *
   * @remarks
   * Replace the selected data source's export route configuration.
   */
  async updateRoute(
    request: UpdateDataExportRouteRequest,
    security?: UpdateDataExportRouteSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DataExportRoute> {
    return unwrapAsync(dataExportsUpdateRoute(
      this,
      request,
      security,
      options,
    ));
  }
}
